export const MARKET_LABEL = { pts: "PTS", reb: "REB", ast: "AST", fg3m: "3PM", tov: "TOV", pr: "PTS+REB", pa: "PTS+AST", ra: "REB+AST", pra: "PRA" };
const PARTS = { pr: ["pts", "reb"], pa: ["pts", "ast"], ra: ["reb", "ast"], pra: ["pts", "reb", "ast"] };
// Live/final pick state: "won" once an over is reached (or an under survives the final), "lost" once it can no longer win.
export function pickOutcome(p, live, status) {
  if (p.result === "win") return "won";
  if (p.result === "loss") return "lost";
  if (p.result || !live || !["in", "post"].includes(status)) return null;
  const v = liveValue(p, live);
  if (v == null) return null;
  if (p.side === "over") return v > p.line ? "won" : status === "post" ? "lost" : null;
  return v > p.line ? "lost" : status === "post" && v < p.line ? "won" : null;
}
export function liveValue(p, live) {
  if (!live) return null;
  const parts = (PARTS[p.market] || [p.market]).map((k) => live[k]);
  return parts.some((v) => !Number.isFinite(v)) ? null : parts.reduce((a, b) => a + b, 0);
}
// "3/5" toward an over (5 = smallest winning total), "3/7" used of an under's allowance.
export function pickProgress(p, live, status) {
  const v = status === "in" || status === "post" ? liveValue(p, live) : null;
  if (v == null) return null;
  const target = p.side === "over" ? Math.floor(p.line) + 1 : Math.ceil(p.line) - 1;
  return { value: v, target, ratio: target > 0 ? Math.min(v / target, 1) : 1 };
}
export const SCAN_MARKETS = ["pts", "reb", "ast", "fg3m", "pra"];
export const BOOKMAKERS = ["Bet365", "DraftKings", "FanDuel", "Assos365", "Stoiximan"];
export const DEFAULT_BOOKMAKER = "Bet365";
export const pct = (v) => (v == null ? "—" : `${(v * 100).toFixed(1)}%`);
export const evText = (v) => `${v >= 0 ? "+" : ""}${(v * 100).toFixed(1)}%`;
// Bookmaker style: over 6.5 is shown as "7+".
export const lineText = (p) => {
  const m = MARKET_LABEL[p.market] || p.market;
  if (p.side === "over" && !Number.isInteger(p.line)) return `${p.line + 0.5}+ ${m}`;
  return `${p.side === "over" ? "Over" : "Under"} ${p.line} ${m}`;
};
export const RESULT_LABEL = { win: "WON", loss: "LOST", push: "PUSH", void: "VOID" };
// "Just updated" window after a lineup (5άδα) change / line move: 15 minutes.
const JUST_UPDATED_MS = 15 * 60 * 1000;
export const isFresh = (ts) => {
  if (!ts) return false;
  const t = Date.parse(ts);
  return Number.isFinite(t) && Date.now() - t < JUST_UPDATED_MS;
};
export const justUpdated = (p) => isFresh(p?.lineup_updated_at);
